import React from 'react';
import Router from './config/router'
const App = () => {
  return <Router/>
}

export default App
